import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { owlClient } from '../../apiUtils/client';
import { QueryKey } from '../../types';
import { useLineType } from './useLineType';

export function useCarrierList() {
  const params = useParams();
  const carrierSlug = params?.carrierSlug;

  const { lineType } = useLineType();

  const { data: carrierList, isLoading: carrierListLoading } = useQuery(
    [QueryKey.CarrierList, lineType],
    () =>
      owlClient.carrier.fetchList({
        query: { insuranceLine: lineType },
      }),
    {
      select: (data) => data.data,
    },
  );

  const childCarriers = useMemo(() => {
    if (carrierSlug) {
      return carrierList?.filter((c) => c.parentCarrierSlug === carrierSlug);
    }
    return null;
  }, [carrierSlug]);

  return {
    carrierList,
    carrierListLoading,
    childCarriers,
  };
}
